import {
  SidebarEmbedName,
  SidebarManageKey,
  SidebarManageName,
  SidebarEmbedKey,
} from './types';

export const SIDEBAR_ITEMS = {
  BUILD: [
    // The order matters.
    {
      key: 'version-overview',
      name: 'Version overview',
      icon: '',
      section: 'build' as const,
    },
    {
      key: 'authentication',
      name: 'Authentication',
      icon: 'personCircleFill',
      section: 'build' as const,
    },
    {
      key: 'triggers',
      name: 'Triggers',
      icon: 'trigger',
      section: 'build' as const,
    },
    {
      key: 'actions',
      name: 'Actions',
      icon: 'action',
      section: 'build' as const,
    },
    { key: 'advanced', name: 'Advanced', icon: '', section: 'build' as const },
  ],
  MANAGE: [
    // The order matters.
    {
      key: SidebarManageKey.publishing,
      name: SidebarManageName.publishing,
      section: 'manage' as const,
    },
    {
      key: SidebarManageKey.versions,
      name: SidebarManageName.versions,
      section: 'manage' as const,
    },
    {
      key: SidebarManageKey.issues,
      name: SidebarManageName.issues,
      section: 'manage' as const,
    },
    {
      key: SidebarManageKey.sharing,
      name: SidebarManageName.sharing,
      section: 'manage' as const,
    },
    {
      key: SidebarManageKey.team,
      name: SidebarManageName.manage,
      section: 'manage' as const,
    },
    {
      key: SidebarManageKey.monitoring,
      name: SidebarManageName.monitoring,
      section: 'manage' as const,
    },
    {
      key: SidebarManageKey.history,
      name: SidebarManageName.history,
      section: 'manage' as const,
    },
  ],
  DASHBOARD: {
    key: 'partner-program',
    name: 'Dashboard',
    icon: '',
    section: 'partner program' as const,
  },
  EMBED: [
    {
      key: SidebarEmbedKey.embed,
      name: SidebarEmbedName.embed,
      section: 'embed' as const,
    },
    {
      isExternal: true,
      key: SidebarEmbedKey.workflowElement,
      name: SidebarEmbedName.workflowElement,
      section: 'embed' as const,
    },
    {
      isExternal: true,
      key: SidebarEmbedKey.workflowApi,
      name: SidebarEmbedName.workflowApi,
      section: 'embed' as const,
    },
    {
      key: SidebarEmbedKey.zapPrefillGenerator,
      name: SidebarEmbedName.zapPrefillGenerator,
      section: 'embed' as const,
    },
    {
      key: SidebarEmbedKey.settings,
      name: SidebarEmbedName.settings,
      section: 'embed' as const,
    },
  ],
  INSIGHTS: {
    key: 'insights',
    name: 'Insights',
    icon: '',
    section: 'insight dashboard' as const,
  },
};

export const SIDEBAR_VERSION_DROPDOWN_VALUES = {
  ALL: 'all',
  PROMOTE: 'promote',
  DEPRECATE: 'deprecate',
  MIGRATE: 'migrate',
  CLONE: 'clone',
};

export const VERSIONLESS_ROUTES = [
  SidebarManageKey.team,
  SidebarManageKey.history,
  SidebarManageKey.issues,
  SidebarManageKey.versions,
  SidebarManageKey.sharing,
  SidebarManageKey.publishing,
  ...SIDEBAR_ITEMS.EMBED.map(r => r.key),
  SIDEBAR_ITEMS.INSIGHTS.key,
];
